import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedSchool: null,
  selectedEvent: null,
  selectedGrade: null,
};

const omrUploadSlice = createSlice({
  name: "omrUpload",
  initialState,
  reducers: {
    setContext: (state, action) => {
      state.selectedSchool = action.payload.school;
      state.selectedEvent = action.payload.event;
    },
    setSelectedGrade: (state, action) => {
      state.selectedGrade = action.payload;
    },
    clearContext: (state) => {
      state.selectedSchool = null;
      state.selectedEvent = null;
      state.selectedGrade = null;
    },
  },
});

export const { setContext, setSelectedGrade, clearContext } =
  omrUploadSlice.actions;
export default omrUploadSlice.reducer;
